// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .cg-tree {
  background-color: transparent;
  padding: 4px 0 0 16px;
}
/*# sourceMappingURL=CgTree.css.map */`, "",{"version":3,"sources":["webpack://./CgTree.less","webpack://./src/components/CgTree/CgTree.less"],"names":[],"mappings":"AAAA;EAEE,6BAAA;EACA,qBAAA;ACAF;AACA,qCAAqC","sourcesContent":[".presize-root { \n .cg-tree {\n  background-color: transparent;\n  padding: 4px 0 0 16px;\n}\n \n}",".presize-root .cg-tree {\n  background-color: transparent;\n  padding: 4px 0 0 16px;\n}\n/*# sourceMappingURL=CgTree.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
